import { PoolType } from "./types";

 const stakings : PoolType[] = [
    {
      id: 0,
      name: "STT",
      image_url: "",
      address: "EQA0mD4iXDCgSo_Nic7unchNtybSU-rxFBgbYfkVwHLaI-mL",
      quote: { 
        address: "kQCG7dR4r0Z3b1YjfHCJs8PozInwPOFSMtp6qN1u6YB52ntw", 
        decimals: 9,
        symbol: "STT"
        },
      reward: { 
        address: "kQAL6sA-8C9kUCwkYZlLb09q1SzzRIo1mmrCaaUwtBtpj0O2", 
        decimals: 9,
        symbol:"RTT"
         }
    },
    {
        id: 1,
        name: "RTT",
        image_url: "",
        address: "EQA0mD4iXDCgSo_Nic7unchNtybSU-rxFBgbYfkVwHLaI-mL",
        quote: { 
          address: "kQCG7dR4r0Z3b1YjfHCJs8PozInwPOFSMtp6qN1u6YB52ntw", 
          decimals: 9,
           symbol: "STT"
          },
        reward: { 
          address: "kQAL6sA-8C9kUCwkYZlLb09q1SzzRIo1mmrCaaUwtBtpj0O2", 
          decimals: 9,
           symbol: "RTT"
           }
      },
    
  ]

  export default stakings;